import React from 'react';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function PurchasedAdditionalServices({
  purchasedAdditionalServices = [],
}) {
  const { trans } = useTranslation();
  return (
    <div>
      <h3
        className="font-big-bold m-0"
      >
        {trans('purchased')}
      </h3>
      <ul
        className="flex flex-col gap-1 list-none p-0"
      >
        {
            purchasedAdditionalServices?.map((service) => (
              <li
                key={service.id}
                className="flex justify-between text-base items-center"
              >
                <p className="m-0">
                  {service.service.name}
                </p>
                {' '}
                <p className="m-0">
                  {service.paidAmount.amount}
                  {' '}
                  {trans('gel')}
                </p>
              </li>
            ))
          }
      </ul>
    </div>
  );
}

export default PurchasedAdditionalServices;
